import {
    ServiceCreateForm,
    ServiceData,
    ServiceListResponse,
    ServiceQuery,
    ServiceRequirementData,
    ServiceStatusUpdateForm,
    ServiceUpdateForm,
    TagBindingForm,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/service';

export class ServiceApi {
    public static async create(service: ServiceCreateForm): Promise<void> {
        await axios.post(`${BASE_URL}`, { service });
    }

    public static async update(id: string, service: ServiceUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { service });
    }

    public static async updateRequirements(id: string, requirements: ServiceRequirementData[]): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/requirements`, { requirements });
    }

    public static async updateStatus(id: string, statusForm: ServiceStatusUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { service: statusForm });
    }

    public static async remove(id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}`);
    }

    public static async bindTag(id: string, tag: TagBindingForm): Promise<void> {
        await axios.post(`${BASE_URL}/${id}/tag`, { tag });
    }

    public static async unbindTag(id: string, tagId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}/tag/${tagId}`);
    }

    public static async get(id: string): Promise<ServiceData> {
        const res = await axios.get(`${BASE_URL}/${id}`);

        return res.data.service;
    }

    public static async getList({ query, ...params }: ServiceQuery): Promise<ServiceListResponse> {
        const res = await axios.get(`${BASE_URL}`, { params: { ...params, query: query && query.trim() } });

        return res.data;
    }
}

export { BASE_URL as SERVICE_BASE_URL };
